import element from './element';
import { isBlank } from './object';

export type ScrollMod = 'innerWindow' | 'innerPage';
export interface CalScrollYaxisParams {
  scrollMod?: ScrollMod;
  wrappedBottomDistance?: number;
  tablePrefix?: string;
  wrapCls?: string;
  tableElementSelector?: string;
}

/** 计算table scroll.y的高度 */
export function calcScrollYaxis(initTableOptions: CalScrollYaxisParams) {
  const {
    tableElementSelector,
    tablePrefix = 'beehive-table',
    wrappedBottomDistance = 40,
    scrollMod = 'innerWindow',
    wrapCls,
  } = initTableOptions;
  if (scrollMod === 'innerWindow') {
    const tableElement = document.querySelector(tableElementSelector || `.${tablePrefix}`) as HTMLElement;
    const tableBody = tableElement ? tableElement.querySelector(`.${tablePrefix}-scroll .${tablePrefix}-body`) : null;
    //  wrapCls 限定feet范围, 可能会取到其他beehive-table 导致计算结果错误
    const siblingsSelector = tableElementSelector ? `${tableElementSelector} ~ *` : `.${tablePrefix} ~ *`;
    const feet = document.querySelectorAll(!!wrapCls ? `.${wrapCls} ${siblingsSelector}` : `${siblingsSelector}`);
    if (tableElement && tableBody) {
      const tableBodyTop = tableBody.getBoundingClientRect().top;
      let feetHeight = 0;
      for (let i = 0; i < feet.length; i++) {
        feetHeight += element.getOuterHeight(feet[i] as HTMLElement);
      }
      const tableHeight = window.innerHeight - tableBodyTop - feetHeight - wrappedBottomDistance;
      return tableHeight;
    }
  }
  return false;
}

export function getScrollXAxis(initTableOptions: CalScrollYaxisParams) {
  const { tableElementSelector, tablePrefix = 'beehive-table' } = initTableOptions;
  const tableElement = document.querySelector(tableElementSelector || `.${tablePrefix}`) as HTMLElement;
  const tableBody = tableElement ? tableElement.querySelector(`.${tablePrefix}-scroll .${tablePrefix}-body`) : null;
  if (tableElement && tableBody) {
    return tableBody.clientWidth;
  }
  return 0;
}

export function getTableCellClassName(key: string) {
  return `mpc-table-col-${key}`;
}

export const defaultColumnRender = (v: any, r: any, i: number) => {
  return isBlank(v) ? '--' : v;
};
